import Vue from 'vue'
import VueRouter from 'vue-router'
import  Layout from './Layout.js'
import {getStore, setStore} from "@/util/store";

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    name: 'login',
    component: Layout,
    redirect: '/wel/index',
    children: [{
      path: 'index',
      name: '首页',
      meta: {
        title: '首页',
        i18n: 'dashboard',
        path: '/wel/index'
      },
      component: () =>
          import('@/views/wel/index')
    }],
    meta: {
      title: '盈峰',

    },
  },
  ...Layout,
]
//创建路由
export const createRouter = () => new VueRouter({
  routes: [...routes,]
})
const router = createRouter()

export function resetRouter() {  // 重置路由 比如用于身份验证失败，需要重新登录时 先清空当前的路有权限
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router
